import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";

const mutations = {
  [types.GET_OVERTIME_RULES_BEGIN](state) {
    state.overtimerulesGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_OVERTIME_RULES_SUCCESS](state, overtimerules) {
    state.overtimerulesGetError = null;
    state.overtimeRules = overtimerules;
    state.overtimerulesGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_OVERTIME_RULES_ERROR](state, err) {
    state.overtimerulesGetState = API_STATES.REQUEST_ERROR;
    state.overtimerulesGetError = err;
  },

  [types.DELETE_OVERTIME_RULE_BEGIN](state) {
    state.deleteOvertimeRuleState = API_STATES.REQUEST_PENDING;
  },
  [types.DELETE_OVERTIME_RULE_SUCCESS](state) {
    state.deleteOvertimeRuleError = null;
    state.deleteOvertimeRuleState = API_STATES.REQUEST_SUCCESS;
  },
  [types.DELETE_OVERTIME_RULE_ERROR](state, err) {
    state.deleteOvertimeRuleState = API_STATES.REQUEST_ERROR;
    state.deleteOvertimeRuleError = err;
  },

  [types.APPLY_OVERTIME_RULE_BEGIN](state) {
    state.applyOvertimeRuleState = API_STATES.REQUEST_PENDING;
  },
  [types.APPLY_OVERTIME_RULE_SUCCESS](state) {
    state.applyOvertimeRuleError = null;
    state.applyOvertimeRuleState = API_STATES.REQUEST_SUCCESS;
  },
  [types.APPLY_OVERTIME_RULE_ERROR](state, err) {
    state.applyOvertimeRuleState = API_STATES.REQUEST_ERROR;
    state.applyOvertimeRuleError = err;
  }
};

export default mutations;